module.exports = __webpack_public_path__ + "static/media/icons8-calendar.906f578e.svg";